var map = {
	"./anna.png": "5e97",
	"./closeTrash.png": "0c4c",
	"./commentModAfter.png": "2d48",
	"./commentModBefore.png": "f0f7",
	"./dong.png": "a66c",
	"./draw/annaSpeaker.png": "b128",
	"./draw/eddySpeaker.png": "371b",
	"./draw/hazelSpeaker.png": "9b77",
	"./draw/nanaSpeaker.png": "9311",
	"./draw/richardSpeaker.png": "c1b7",
	"./dummy_img.jpg": "e799",
	"./eddy.png": "beb1",
	"./ha.png": "b82c",
	"./hazel.png": "1735",
	"./icon/facebook.svg": "1c90",
	"./icon/github.svg": "b341",
	"./icon/google.svg": "4225",
	"./imageDU.png": "4f94",
	"./imageHA.png": "014c",
	"./imageHW.png": "f926",
	"./imageNY.png": "f3a7",
	"./imageYB.png": "26ea",
	"./intro_with_long_HU.mp3": "bb14",
	"./intro_with_long_soprano.mp3": "d563",
	"./jo.png": "22a2",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./logodark.png": "71ef",
	"./logolight.png": "cc0e",
	"./na.png": "9545",
	"./nana.png": "4179",
	"./openTrash.png": "b6a0",
	"./profile.png": "c3e7",
	"./richard.png": "abf5",
	"./won.png": "23fc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";